import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "Overview of React",
      nestedContent: [
        { id: 1, text: "•	History and features of React.", dummyText: [] },
        { id: 2, text: "•	Setting up the development environment (IDE: VS Code, Webpack, Create React App).", dummyText: [] },
        { id: 3, text: "•	Understanding React project structure and files.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "React Basics",
      nestedContent: [
        { id: 1, text: "•	Writing and running a simple React component.", dummyText: [] },
        { id: 2, text: "•	Understanding JSX and how it translates to JavaScript.", dummyText: [] },
        { id: 3, text: "•	Using functional components and class components.", dummyText: [] },
        { id: 4, text: "•	Introduction to props and state.", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: "Basic Syntax and Structure",
        nestedContent: [
          { id: 1, text: "• 		Variables, data types, and basic JavaScript syntax.", dummyText: [] },
          { id: 2, text: "• 		Conditional rendering and lists in React.", dummyText: [] },
          { id: 3, text: "•	Understanding component structure and rendering flow.", dummyText: [] },
         
        
        ],
      },
      
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title: " Components in Depth",
      nestedContent: [
        { id: 1, text: "• 		Functional vs Class components.", dummyText: [] },
        { id: 2, text: "•	Component lifecycle methods (for class components).", dummyText: [] },
        { id: 3, text: "•	Using useState and useEffect hooks in functional components.", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: "  JSX and Rendering",
      nestedContent: [
        { id: 1, text: "•		Understanding JSX, rendering elements and components.", dummyText: [] },
        { id: 2, text: "•	Conditional rendering with ternary operators and logical expressions.", dummyText: [] },
        { id: 3, text: "•	Rendering lists and keys in React.", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: " Event Handling",
        nestedContent: [
          { id: 1, text: "•	Handling user input and events in React (click, change, submit).", dummyText: [] },
          { id: 2, text: "•	Passing events between components.", dummyText: [] },
          { id: 3, text: "•	Synthetic events and event delegation in React.", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: "Understanding State in React",
      nestedContent: [
        { id: 1, text: "•	Defining and updating state using useState.", dummyText: [] },
        { id: 2, text: "•	Using state in class components (this.setState).", dummyText: [] },
        { id: 3, text: "•	Handling complex state (objects, arrays).", dummyText: [] },
        
       
      ],
    },
    {
      id: 4,
      title: " Passing Props to Components",
      nestedContent: [
        { id: 1, text: "•	Passing data from parent to child components using props.", dummyText: [] },
        { id: 2, text: "•	Default props and prop types", dummyText: [] },
        { id: 3, text: "•	Prop drilling and managing nested components.", dummyText: [] },
        
      ],
    },
    {
        id: 5,
        title: " Lifting State Up",
        nestedContent: [
          { id: 1, text: "•	Sharing state between components by lifting state up.", dummyText: [] },
          { id: 2, text: "•	Using callback functions to modify state in parent components.", dummyText: [] },
          
        ],
      },
      {
        id: 6,
        title: "   Context API",
        nestedContent: [
          { id: 1, text: "•	Using React's Context API for global state management.", dummyText: [] },
          { id: 2, text: "•	Creating context and using useContext to access global state.", dummyText: [] },
          
        ],
      },
     
  ];
 
  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: "Introduction to React Router",
      nestedContent: [
        { id: 1, text: "•	Setting up React Router in a project.", dummyText: [] },
        { id: 2, text: "•	Defining routes and linking between pages.", dummyText: [] },
        { id: 3, text: "•	Understanding the BrowserRouter and Route components.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "Navigating with Links",
      nestedContent: [
        { id: 1, text: "•	Using Link and NavLink components for navigation.", dummyText: [] },
        { id: 2, text: "•	Programmatic navigation using useNavigate and history.push.", dummyText: [] },
        { id: 3, text: "Using<a  heref “ https://iiautomate.com/ >  <a/>”", dummyText: [] },
      ],
    },
    {
        id: 7,
        title: "Dynamic Routing",
        nestedContent: [
          { id: 1, text: "•	Passing parameters to routes with dynamic segments.", dummyText: [] },
          { id: 2, text: "•	Using route parameters in URL and query strings.", dummyText: [] },
          { id: 3, text: "•	Nested routes and creating multi-level navigation.", dummyText: [] },
        
        ],
      },
      
      
      
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Building Forms in React",
      nestedContent: [
        { id: 1, text: "•	Controlled vs uncontrolled components.", dummyText: [] },
        { id: 2, text: "•	Handling for’m inputs and managing multiple form fields.", dummyText: [] },
        { id: 3, text: " •	Form submission and event handling.", dummyText: [] },

       
      ],
    },
    {
      id: 8,
      title: " Validation in Forms",
      nestedContent: [
        { id: 1, text: "•	Validating form inputs in React.", dummyText: [] },
        { id: 2, text: "•	Handling validation errors and displaying messages.", dummyText: [] },
        { id: 3, text: "•	Using libraries like Formik and Yup for form validation.", dummyText: [] },
      ],
    },
    {
        id: 9,
        title: "Advanced Form Handling",
        nestedContent: [
          { id: 1, text: "•	Managing dynamic forms and adding/removing fields.", dummyText: [] },
          { id: 2, text: "•	Managing complex form states in large applications.", dummyText: [] },
        ],
      },
      
      
      
  ];

  const extraAdvancedModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "   Fetching Data with React",
      nestedContent: [
        { id: 1, text: "•	Using the fetch API to get data from external sources.", dummyText: [] },
        { id: 2, text: "•	Displaying data in components and handling loading states.", dummyText: [] },
        { id: 3, text: " •	Using useEffect for data fetching and managing side effects.", dummyText: [] },
      ],
     
    },
    {
      id: 10,
      title: "State Management with Redux",
      nestedContent: [
        { id: 1, text: "•	Introduction to Redux (Actions, Reducers, Store).", dummyText: [] },
        { id: 2, text: "•	Setting up a Redux store in React.", dummyText: [] },
        { id: 3, text: " •	Dispatching actions and connecting Redux to components via connect.", dummyText: [] },
      ],
     

    },
    {
      id: 11,
      title: "Advanced State Management",
      nestedContent: [
        { id: 1, text: "•	Using Redux for asynchronous actions.", dummyText: [] },
        { id: 2, text: "•	Implementing Redux Toolkit to simplify Redux workflows.", dummyText: [] },
        { id: 3, text: "•	Using the useDispatch and useSelector hooks for Redux.", dummyText: [] },
       
      ],
    },
    
  ];

  const andLocalModuleContent = [
    //ExtraAdvancedModuleSections
    {
      id: 13,
      title: " Unit and Integration Testing",
      nestedContent: [
        { id: 1, text: "	•	Introduction to testing React components with test.", dummyText: [] },
        { id: 2, text: "•	Writing tests for state and props, event handling, and rendering.", dummyText: [] },
        { id: 3, text: "•	Using React Testing Library for component testing.", dummyText: [] },
      ],
    },
    {
      id: 14,
      title: "End-to-End Testing",
      nestedContent: [
        { id: 1, text: "•	Using Cypress or Selenium for end-to-end testing.", dummyText: [] },
        { id: 2, text: "•	Testing user interactions, API calls, and browser behavior.", dummyText: [] },
        { id: 3, text: "•	Writing and running automated tests in CI/CD pipelines", dummyText: [] },
       
      ],
    },
    {
      id: 15,
      title: "   Debugging React Apps",
      nestedContent: [
        { id: 1, text: "•	Using React DevTools for debugging components.", dummyText: [] },
        { id: 2, text: "•	Identifying performance bottlenecks and optimizing re-renders.", dummyText: [] },
        { id: 3, text: "•	Handling errors in React using error boundaries.", dummyText: [] },
      ],
    },
    
  ];
  const andUlteraLocalModuleContent = [
    //ExtraAdvancedModuleSections
    
    {
        id: 16,
        title: "  Project Requirements: ",
        nestedContent: [
          { id: 1, text: "• 			Design and develop a multi-page React application", dummyText: [] },
          { id: 2, text: "• 				Implement form handling, validation, and API data fetching.", dummyText: [] },
          { id: 3, text: "• 				Use React Router for navigation and state management (using Context API, Redux, or similar).", dummyText: [] },
          { id: 4, text: "• 				Build responsive and interactive UI components with React.", dummyText: [] },
          { id: 5, text: "• 					Write unit tests and ensure code coverage for critical components.", dummyText: [] },
          { id: 6, text: "• 				Deploy the application using services like Netlify, Vercel, or Firebase Hosting,Go Daddy", dummyText: [] },
          { id: 7, text: "• 					Document and present the final project.", dummyText: [] },
         
        ],
      },
    
  ];

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-49px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        Introduction to React
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
      Core Concepts of React
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
       React State and Props
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
        React Router and Navigation
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
   React Forms and Validation
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
      Data Fetching and State Management
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
       <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndLocalModule(!toggleAndLocalModule)}
      >
       Testing and Debugging React Apps
      </div>

      {toggleAndLocalModule && (
        <div className="list-tab mt-3">
          {andLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andLocal")}
              >
                {title}
                <span>{AndLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndUlteraLocalModule(!toggleAndUlteraLocalModule)}
      >
       Final Project and Deployment
      </div>

      {toggleAndUlteraLocalModule && (
        <div className="list-tab mt-3">
          {andUlteraLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andUlteraLocal")}
              >
                {title}
                <span>{AndUlteraLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndUlteraLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LearningPathTFD;




